import React from "react";
import { useLanguage } from "../../context/LanguageContext";

/* Big display section titles, drawn to match the artwork headings on yourstory.com.
 *
 * The wording is STATIC: it comes from /public/i18n/*.json (home.* keys) and is never sent to
 * a translator. The artwork splits English words around a drawing (Conversat[mic]ons, Sp[o]tlight),
 * which cannot be done for Tamil, so in Tamil each title renders as plain text with its drawing
 * placed after it (the `--ta` modifier in home.css tunes size/spacing for Tamil letters). */

const Star = () => (
  <svg className="ys-title__star" viewBox="0 0 64 64" aria-hidden="true">
    <path
      d="M40 4l4.5 12.5 13-6-5.5 13.5L66 27l-14 4.5 8 11.5-13.5-3-1.5 14L38 44 27 55l2.5-14.5L14 42l11-9-14-8 15-1-4-14 13 6z"
      fill="#ED1C24"
      transform="translate(-6 -2) scale(.95)"
    />
    <path
      d="M2 62C8 46 16 34 28 28M8 62C14 50 20 42 30 36"
      stroke="#ED1C24"
      strokeWidth="1.6"
      fill="none"
      strokeLinecap="round"
    />
  </svg>
);

const Mic = () => (
  <svg
    className="ys-title__mic"
    viewBox="525 0 55 115"
    preserveAspectRatio="xMidYMax meet"
    aria-hidden="true"
  >
    <path
      fill="#FF2020"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M531.384 46.913c-1.783-3.592-3.55-7.194-5.292-10.806-1.373-2.844-.857-4.51 1.886-6.11 4.338-2.534 8.679-5.061 13.02-7.588 2.68-1.56 5.36-3.12 8.038-4.681.157-.092.322-.178.486-.263.832-.434 1.666-.87 1.6-2.127-.015-.364.423-.577.751-.736.467-.23.938-.45 1.408-.67.85-.39 1.689-.802 2.517-1.235 3.257-1.741 3.449-1.312 4.454.93.174.386.371.827.613 1.32 1.671 3.413 3.282 6.856 4.894 10.298a828.525 828.525 0 0 0 3.888 8.228c1.501 3.117 1.47 3.42-1.561 4.952a2.525 2.525 0 0 0-.248.153c-.219.147-.439.295-.749.226-.172-.34-.151-.71-.13-1.086.024-.44.049-.886-.236-1.285-.596.274-.547.742-.5 1.18.013.117.025.233.024.342-.018 3.697-.015 7.395-.011 11.092l.002 2.217c0 1.525 0 2.282-.378 2.678-.388.406-1.175.433-2.768.52-1.339.072-1.796-.226-1.771-1.667.082-4.288.057-8.581.033-12.873l-.011-2.001c0-.12.015-.247.03-.377.056-.471.117-.977-.552-1.23-.347.457-.278.982-.217 1.449l.01.076c.226 1.726-.2 2.932-2.136 3.23-.816.125-.997.755-.982 1.525l.003.117c.033 1.63.067 3.264-.021 4.89-.06 1.085.344 1.71 1.251 2.26 2.217 1.35 2.255 1.534 1.685 4.093-.03-.002-.062 0-.095 0-.071.003-.143.005-.192-.025-.716-.432-1.427-.871-2.138-1.31-1.506-.931-3.011-1.861-4.555-2.72-1.111-.615-1.448-1.35-1.42-2.597.084-3.856.012-3.89-3.575-2.462-.291.116-.596.208-.903.3-.881.263-1.771.53-2.347 1.4-.339.514-.694 1.017-1.048 1.52-.576.82-1.152 1.639-1.663 2.496-3.713 6.224-1.689 11.345 5.273 13.35a77.518 77.518 0 0 1 6.499 2.189c1.589.61 1.601.61 1.604-1.13l.004-1.88c.006-3.133.013-6.265-.013-9.397-.009-1.146.275-1.44 1.301-.742l.222.15c1.003.686 2.017 1.378 3.109 1.879.897.408 1.023.94 1.01 1.81a302.197 302.197 0 0 0-.009 4.855c.007 2.032.014 4.065-.032 6.096-.028 1.197.307 1.854 1.377 2.45 3.893 2.17 7.499 4.729 9.992 8.56 1.927 2.966 2.799 6.183 1.83 9.669-1.223 4.388-4.319 7.395-7.76 10.11-.15.119-.316.22-.483.322-.398.242-.801.486-.999.978.058.03.111.063.161.094.098.06.185.112.28.135.209.054.421.093.633.133.146.027.291.054.436.086 3.997.871 7.885 2.03 11.044 4.799 1.395 1.22 2.232 2.562 2.518 3.928h-43.788c.324-1.55 1.357-3.07 3.098-4.423.652-.507 1.35-.95 2.104-1.43.36-.229.733-.466 1.12-.722a195.265 195.265 0 0 1 5.811-1.958c1.777-.065 3.553-.256 5.327-.698 1.407-.348 1.742-.72 1.732-2.027-.025-3.588-.024-7.176-.023-10.765.001-3.094.002-6.188-.014-9.28-.006-1.188.231-1.79 1.576-1.404.754.22 1.561.144 2.324-.06 1.329-.356 1.801.004 1.783 1.495-.067 5.108-.059 10.216-.052 15.324.002 1.62.005 3.24.005 4.86 0 1.647.015 1.653 1.485.86 3.225-1.728 5.896-4.106 8.041-7.06 2.659-3.657 2.906-7.498.582-11.403-1.889-3.173-4.738-5.37-7.766-7.358-.691-.454-.916-.17-.941.539-.031.827-.26 1.679-1.151 1.826l-.294.048c-1.685.278-3.376.557-5.117.13-1.823-.444-2.618-1.78-1.933-3.558.313-.817.717-1.268 1.764-.946 1.405.436 2.887.33 4.341.113l.065-.01c.437-.064.922-.136 1.215-.876-.269.046-.533.096-.794.145-1.399.262-2.686.503-3.988.168-.079-.02-.163-.036-.248-.053-.433-.084-.892-.172-.847-.793.061-.922-.543-1.161-1.183-1.415l-.128-.05c-1.687-.681-3.415-1.244-5.144-1.807-1.086-.354-2.173-.708-3.25-1.09-3.406-1.213-6.296-3.105-7.165-6.96-.657-2.904.178-5.563 1.535-8.1.343-.644.687-1.285 1.041-1.946l.417-.776c-.107-.018-.188-.038-.253-.054-.103-.024-.163-.04-.213-.021-1.037.37-2.071.745-3.105 1.12l-1.44.52c-2.714.984-4.356.36-5.62-2.192Z"
    />
  </svg>
);

const Arrow = () => (
  <svg className="ys-title__arrow" viewBox="0 0 70 60" aria-hidden="true">
    <path
      d="M4 14c18-12 46-8 54 18"
      stroke="#ED1C24"
      strokeWidth="3"
      fill="none"
      strokeLinecap="round"
    />
    <path
      d="M50 26l9 8 6-11"
      stroke="#ED1C24"
      strokeWidth="3"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export function TopPicksTitle() {
  const { lang, t } = useLanguage();
  const text = t("home.topPicks");
  if (lang === "ta") {
    return (
      <h2 className="ys-title ys-title--picks ys-title--ta" aria-label={text}>
        <span>{text}</span>
        <Star />
      </h2>
    );
  }
  return (
    <h2 className="ys-title ys-title--picks" aria-label={text}>
      <span>Top</span>
      <Star />
      <span>Picks</span>
    </h2>
  );
}

export function PlaybookTitle() {
  const { lang, t } = useLanguage();
  const text = t("home.playbook");
  if (lang === "ta") {
    return (
      <h2 className="ys-title ys-title--desk ys-title--ta" aria-label={text}>
        <span className="ys-title__underlined">{text}</span>
      </h2>
    );
  }
  return (
    <h2 className="ys-title ys-title--desk" aria-label={text}>
      <span>The</span>
      <span className="ys-title__underlined">Playbook</span>
    </h2>
  );
}

export function ConversationsTitle() {
  const { lang, t } = useLanguage();
  const text = t("home.conversations");
  if (lang === "ta") {
    return (
      <h2
        className="ys-title ys-title--center ys-title--conv ys-title--ta"
        aria-label={text}
      >
        <span>{text}</span>
        <Mic />
      </h2>
    );
  }
  return (
    <h2 className="ys-title ys-title--center ys-title--conv" aria-label={text}>
      <span aria-hidden="true">Discuss</span>
      <Mic />
      <span aria-hidden="true">ons</span>
    </h2>
  );
}

/* `children` lets a section override the wording; pass already-translated static text (t(...)). */
export function FeaturedTitle({ children }) {
  const { lang, t } = useLanguage();
  const text = children || t("home.newLaunches");
  return (
    <h2
      className={`ys-title ys-title--featured${lang === "ta" ? " ys-title--ta" : ""}`}
      aria-label={text}
    >
      <span>{text}</span>
      <Arrow />
    </h2>
  );
}

export function SpotlightTitle() {
  const { lang, t } = useLanguage();
  const text = t("home.spotlight");
  if (lang === "ta") {
    return (
      <h2 className="ys-title ys-title--spot ys-title--ta" aria-label={text}>
        <span>{text}</span>
        {/* <span className="ys-title__o" aria-hidden="true">
          <svg
            className="ys-title__icon"
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <g>
              <path
                fill="white"
                d="M503.652,18.735H370.099c-0.118-0.006-0.237-0.008-0.356-0.008c-1.69,0-3.358,0-5.012,0c-0.001,0-0.003,0-0.004,0
      c-50.046,0-84.027,0-135.686,0.008c-4.61,0.001-8.348,3.739-8.347,8.349c0.001,4.611,3.739,8.348,8.349,8.347
      c48.733-0.007,81.74-0.008,127.338-0.008v122.943c-1.798,6.658-3.867,13.111-6.157,19.201
      c-0.747,1.5-1.496,3.054-2.258,4.637c-2.397,4.98-4.877,10.13-7.807,14.513
      c-0.033,0.049-0.066,0.099-0.097,0.149c-7.077,11.096-15.007,19.981-24.945,27.944
      c-8.621,6.111-17.86,10.477-28.24,13.344c-0.002,0-0.004,0.002-0.007,0.002
      c-5.309,1.467-10.815,2.534-16.819,3.261h-13.521
      c-0.394,0-0.787,0.028-1.178,0.083c-1.685,0.24-3.595,0.362-5.678,0.362
      c-5.021,0-10.484-0.7-15.264-1.378l-8.431-2.103l-3.611-0.902
      c-7.752-2.946-14.628-6.855-21.9-11.002c-10.183-6.51-17.022-15.044-24.932-24.917
      l-0.672-0.839c-9.717-14.602-15.659-27.775-18.648-41.354l-2.084-123.936h23.758
      c4.61,0,8.348-3.737,8.348-8.348s-3.738-8.348-8.348-8.348h-31.885
      c-0.119-0.006-0.239-0.008-0.359-0.008c-0.12-0.001-0.242,0.002-0.361,0.008H8.348
      C3.738,18.735,0,22.471,0,27.083c0,30.797,8.395,60.302,24.276,85.328
      c15.793,24.885,37.959,43.624,64.172,54.334v206.336
      c0,3.335,1.985,6.35,5.048,7.668c3.063,1.319,6.616,0.688,9.039-1.604
      l15.513-14.683l18.013,15.474c1.544,1.326,3.482,2.016,5.442,2.016
      c1.178,0,2.363-0.249,3.476-0.759c2.963-1.358,4.865-4.314,4.871-7.574
      l0.341-182.045c3.058,6.108,6.697,12.307,10.985,18.725
      c0.135,0.201,0.278,0.396,0.429,0.585l0.897,1.12
      c8.515,10.627,16.557,20.665,29.176,28.676c0.111,0.07,0.239,0.147,0.354,0.211
      c7.327,4.178,14.894,8.493,23.575,11.881v26.108
      c0,4.611,3.738,8.348,8.348,8.348h8.825V420.04
      c-27.246,9.695-45.761,35.506-45.761,64.885c0,4.611,3.738,8.348,8.348,8.348
      h121.373c4.61,0,8.348-3.736,8.348-8.348c0-28.93-18.163-54.619-44.892-64.564
      V287.225h8.905c4.61,0,8.348-3.736,8.348-8.348v-26.506
      c9.924-3.355,18.983-7.995,27.542-14.093c0.124-0.089,0.245-0.18,0.363-0.275
      c11.48-9.163,20.614-19.36,28.739-32.085c3.391-5.09,6.133-10.693,8.558-15.726
      v182.889c0,3.335,1.985,6.349,5.048,7.668c3.063,1.319,6.616,0.688,9.039-1.604
      l15.514-14.683l18.015,15.474c1.544,1.326,3.482,2.016,5.441,2.016
      c1.178,0,2.363-0.249,3.476-0.759c2.963-1.358,4.865-4.315,4.871-7.574
      l0.386-207.239c25.826-10.77,47.673-29.362,63.286-53.967
      C503.605,87.385,512,57.88,512,27.083C512,22.472,508.262,18.735,503.652,18.735z
      M88.447,148.499c-41.57-19.893-68.798-62.871-71.525-113.069h120.504
      l0.193,11.467H43.248c-2.444,0-4.767,1.072-6.353,2.933
      c-1.586,1.86-2.276,4.323-1.89,6.737c4.675,29.161,25.499,59.004,53.442,76.932V148.499z
      M133.186,355.455l-9.971-8.566c-1.568-1.347-3.505-2.016-5.438-2.016
      c-2.069,0-4.134,0.766-5.74,2.285l-6.893,6.525V136.557h28.452L133.186,355.455z
      M98.061,119.83c-21.246-13.409-37.774-34.577-44.327-56.238h84.164l0.946,56.238H98.061z
      M307.715,476.578H204.378c3.271-20.304,18.306-37.091,38.786-42.261
      c3.698-0.933,6.292-4.252,6.305-8.066l0.002-139.025h14.025v138.35
      c0.004,3.774,2.54,7.074,6.185,8.053C289.736,439.89,304.466,456.586,307.715,476.578z
      M271.845,270.53h-30.721h-8.825v-13.478c5.293,0.747,11.368,1.509,17.375,1.509
      c2.669,0,5.103-0.147,7.417-0.445h13.454c0.325,0,0.651-0.02,0.974-0.057
      c3.181-0.374,6.246-0.834,9.23-1.385v13.855H271.845z
      M407.758,157.198c-0.242,0.768-0.376,1.584-0.384,2.432
      c-0.008,0.886,0.126,1.741,0.374,2.544l-0.361,193.281l-9.969-8.566
      c-1.567-1.347-3.504-2.016-5.438-2.016c-2.068,0-4.134,0.766-5.74,2.285
      l-6.895,6.526V136.557h28.453L407.758,157.198z
      M413.939,119.83h-40.862V63.593h85.19C451.713,85.254,435.184,106.422,413.939,119.83z
      M424.471,148.058l0.028-15.183c27.463-17.991,47.872-47.48,52.494-76.309
      c0.387-2.414-0.303-4.876-1.89-6.737c-1.586-1.861-3.908-2.933-6.353-2.933
      h-95.676V35.431h122.003C492.373,85.256,465.524,127.975,424.471,148.058z"
              />
            </g>
          </svg>
        </span> */}
      </h2>
    );
  }
  return (
    <h2 className="ys-title ys-title--spot" aria-label={text}>
      <span aria-hidden="true">Milest</span>
      <span className="ys-title__o" aria-hidden="true">
        <svg
          className="ys-title__icon"
          viewBox="0 0 512 512"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <g>
            <path
              fill="white"
              d="M503.652,18.735H370.099c-0.118-0.006-0.237-0.008-0.356-0.008c-1.69,0-3.358,0-5.012,0c-0.001,0-0.003,0-0.004,0
      c-50.046,0-84.027,0-135.686,0.008c-4.61,0.001-8.348,3.739-8.347,8.349c0.001,4.611,3.739,8.348,8.349,8.347
      c48.733-0.007,81.74-0.008,127.338-0.008v122.943c-1.798,6.658-3.867,13.111-6.157,19.201
      c-0.747,1.5-1.496,3.054-2.258,4.637c-2.397,4.98-4.877,10.13-7.807,14.513
      c-0.033,0.049-0.066,0.099-0.097,0.149c-7.077,11.096-15.007,19.981-24.945,27.944
      c-8.621,6.111-17.86,10.477-28.24,13.344c-0.002,0-0.004,0.002-0.007,0.002
      c-5.309,1.467-10.815,2.534-16.819,3.261h-13.521
      c-0.394,0-0.787,0.028-1.178,0.083c-1.685,0.24-3.595,0.362-5.678,0.362
      c-5.021,0-10.484-0.7-15.264-1.378l-8.431-2.103l-3.611-0.902
      c-7.752-2.946-14.628-6.855-21.9-11.002c-10.183-6.51-17.022-15.044-24.932-24.917
      l-0.672-0.839c-9.717-14.602-15.659-27.775-18.648-41.354l-2.084-123.936h23.758
      c4.61,0,8.348-3.737,8.348-8.348s-3.738-8.348-8.348-8.348h-31.885
      c-0.119-0.006-0.239-0.008-0.359-0.008c-0.12-0.001-0.242,0.002-0.361,0.008H8.348
      C3.738,18.735,0,22.471,0,27.083c0,30.797,8.395,60.302,24.276,85.328
      c15.793,24.885,37.959,43.624,64.172,54.334v206.336
      c0,3.335,1.985,6.35,5.048,7.668c3.063,1.319,6.616,0.688,9.039-1.604
      l15.513-14.683l18.013,15.474c1.544,1.326,3.482,2.016,5.442,2.016
      c1.178,0,2.363-0.249,3.476-0.759c2.963-1.358,4.865-4.314,4.871-7.574
      l0.341-182.045c3.058,6.108,6.697,12.307,10.985,18.725
      c0.135,0.201,0.278,0.396,0.429,0.585l0.897,1.12
      c8.515,10.627,16.557,20.665,29.176,28.676c0.111,0.07,0.239,0.147,0.354,0.211
      c7.327,4.178,14.894,8.493,23.575,11.881v26.108
      c0,4.611,3.738,8.348,8.348,8.348h8.825V420.04
      c-27.246,9.695-45.761,35.506-45.761,64.885c0,4.611,3.738,8.348,8.348,8.348
      h121.373c4.61,0,8.348-3.736,8.348-8.348c0-28.93-18.163-54.619-44.892-64.564
      V287.225h8.905c4.61,0,8.348-3.736,8.348-8.348v-26.506
      c9.924-3.355,18.983-7.995,27.542-14.093c0.124-0.089,0.245-0.18,0.363-0.275
      c11.48-9.163,20.614-19.36,28.739-32.085c3.391-5.09,6.133-10.693,8.558-15.726
      v182.889c0,3.335,1.985,6.349,5.048,7.668c3.063,1.319,6.616,0.688,9.039-1.604
      l15.514-14.683l18.015,15.474c1.544,1.326,3.482,2.016,5.441,2.016
      c1.178,0,2.363-0.249,3.476-0.759c2.963-1.358,4.865-4.315,4.871-7.574
      l0.386-207.239c25.826-10.77,47.673-29.362,63.286-53.967
      C503.605,87.385,512,57.88,512,27.083C512,22.472,508.262,18.735,503.652,18.735z
      M88.447,148.499c-41.57-19.893-68.798-62.871-71.525-113.069h120.504
      l0.193,11.467H43.248c-2.444,0-4.767,1.072-6.353,2.933
      c-1.586,1.86-2.276,4.323-1.89,6.737c4.675,29.161,25.499,59.004,53.442,76.932V148.499z
      M133.186,355.455l-9.971-8.566c-1.568-1.347-3.505-2.016-5.438-2.016
      c-2.069,0-4.134,0.766-5.74,2.285l-6.893,6.525V136.557h28.452L133.186,355.455z
      M98.061,119.83c-21.246-13.409-37.774-34.577-44.327-56.238h84.164l0.946,56.238H98.061z
      M307.715,476.578H204.378c3.271-20.304,18.306-37.091,38.786-42.261
      c3.698-0.933,6.292-4.252,6.305-8.066l0.002-139.025h14.025v138.35
      c0.004,3.774,2.54,7.074,6.185,8.053C289.736,439.89,304.466,456.586,307.715,476.578z
      M271.845,270.53h-30.721h-8.825v-13.478c5.293,0.747,11.368,1.509,17.375,1.509
      c2.669,0,5.103-0.147,7.417-0.445h13.454c0.325,0,0.651-0.02,0.974-0.057
      c3.181-0.374,6.246-0.834,9.23-1.385v13.855H271.845z
      M407.758,157.198c-0.242,0.768-0.376,1.584-0.384,2.432
      c-0.008,0.886,0.126,1.741,0.374,2.544l-0.361,193.281l-9.969-8.566
      c-1.567-1.347-3.504-2.016-5.438-2.016c-2.068,0-4.134,0.766-5.74,2.285
      l-6.895,6.526V136.557h28.453L407.758,157.198z
      M413.939,119.83h-40.862V63.593h85.19C451.713,85.254,435.184,106.422,413.939,119.83z
      M424.471,148.058l0.028-15.183c27.463-17.991,47.872-47.48,52.494-76.309
      c0.387-2.414-0.303-4.876-1.89-6.737c-1.586-1.861-3.908-2.933-6.353-2.933
      h-95.676V35.431h122.003C492.373,85.256,465.524,127.975,424.471,148.058z"
            />
          </g>
        </svg>
      </span>
      <span aria-hidden="true">nes</span>
    </h2>
  );
}

export function BusinessFirstTitle() {
  const { lang, t } = useLanguage();
  const text = t("home.businessFirst");
  if (lang === "ta") {
    return (
      <h2
        className="ys-title ys-title--center ys-title--first ys-title--ta"
        aria-label={text}
      >
        {/* <span>{text}</span> */}
        <span>தொடக்க நிறுவனப்</span>
      <span className="ys-title__first">பயணம்</span>
      </h2>
    );
  }
  return (
    <h2 className="ys-title ys-title--center ys-title--first" aria-label={text}>
      <span>Business</span>
      <span className="ys-title__first">First</span>
    </h2>
  );
}

export function InDepthTitle() {
  const { lang, t } = useLanguage();
  const text = t("home.inDepth");
  return (
    <h2
      className={`ys-title ys-title--center ys-title--depth${lang === "ta" ? " ys-title--ta" : ""}`}
      aria-label={text}
    >
      {text}
    </h2>
  );
}
